/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t){this._store=t}destroy(){this._store.destroy()}get(t){return this._store.get(t)}put(t,s){this._store.put(t,s)}}export{t as ElevationQueryTileCache};
